const stateRoot = (state) => state.register;

export const getEmail = (state) => stateRoot(state).email;

export const getPassword = (state) => stateRoot(state).password;

export const getOrganizationName = (state) => stateRoot(state).organization_name;

export const getFirstName = (state) => stateRoot(state).firstName;

export const getMiddleName = (state) => stateRoot(state).middleName;

export const getLastName = (state) => stateRoot(state).lastName;

export const getInviteCode = (state) => stateRoot(state).inviteCode;

export const getStaffInviteCode = (state) => stateRoot(state).staffInviteCode;

export const getIsRegistering = (state) => stateRoot(state).registering;

export const getIsRegistered = (state) => stateRoot(state).registered;

export const getAccountId = (state) => stateRoot(state).account_id;

export const getIsActive = (state) => stateRoot(state).is_active;
